import { atom, selector } from 'recoil'
import {
  ConfirmStyleType, FooterStyleType,
  InsertStyleType,
  MvmoType,
  PartnerListType,
  TermsStyleType,
  JoinTerms,
  UiData, VerifyStyleType
} from 'src/types/type'

const TelTypeState = atom<number>({
  key: 'TelTypeState',
  default: 0
})
const TelNumState = atom<string>({
  key: 'TelNumState',
  default: ''
})
const TimeoutState = atom<number>({
  key: 'TimeoutState',
  default: 0
})
const TransIdState = atom<string>({
  key: 'TransIdState',
  default: ''
})
const authKeyState = atom<string | undefined>({
  key: 'authKeyState',
  default: undefined
})
const CertCheckState = atom<boolean>({
  key: 'CertCheckState',
  default: false
})
const MvmoTermsState = atom<MvmoType>({
  key: 'MvmoTermsState',
  default: {
    Terms: '',
    TermsTitle: '',
  }
})
const TermsAgreeState = atom<number[]>({
  key: 'TermsAgreeState',
  default: [0, 0, 0, 0, 0, 0, 0, 0, 0]
})
const MvnoCheckValue = atom<boolean>({
  key: 'MvnoCheckValue',
  default: false
})
const VulnerableCheckState = atom<boolean>({
  key: 'VulnerableCheckState',
  default: false,
})
const AllCheckState = atom<boolean>({
  key: 'AllCheckState',
  default: false
})
const CertNumState = atom<string>({
  key: 'CertNumState',
  default: ''
})

const PartnerListData = atom<PartnerListType>({
  key: 'PartnerData',
  default: {
    ButtonMsgAfter: '',
    ButtonMsgBefore: '',
    DelayRewardMin: 0,
    FeeCost: 0,
    FeeRate: 0,
    FeeType: 0,
    FontColor: '',
    FontSize: '',
    Image1: '',
    Image2: '',
    JoinURL: '',
    NotiContent: '',
    PCODE: '',
    PGroup: '',
    PName: '',
    PSKey: '',
    RewardAPI: '',
    RewardURI: '',
    UiData: '',
    UiType: '',
    SKTJoin: 'Y',
    KTJoin: 'Y',
    LGUPJoin: 'Y',
    JoinBlockMsg: '',
  }
})
const TermsListState = atom<JoinTerms[]>({
  key: 'TermsListState',
  default: [
    // SKT
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    },
    // KT
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    },
    // LGUP
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    }
  ]
})

const TermsSelector = selector({
  key: 'TermsSelector',
  get: ({ get }) => get(TermsListState)?.[get(TelTypeState)],
})

// 필수약관 동의 여부
export const IsAgreeAllRequiredTermsSelector = selector({
  key: 'IsAgreeAllRequiredTermsSelector',
  get: ({ get }) => get(TermsSelector)?.Terms
    .filter((terms) => terms.Required === 1 && terms.Order !== undefined)
    .every((terms) => get(TermsAgreeState)[terms.Order! - 1] === 1) ?? false,
})

const RecoilStateList = selector({
  key: 'RecoilStateList',
  get: ({ get }) => {
    return {
      TelType: get(TelTypeState),
      PhoneNum: get(TelNumState),
      Timeout: get(TimeoutState),
      TransId: get(TransIdState),
      CertCheck: get(CertCheckState),
      VulnerableCheck: get(VulnerableCheckState),
      AllTermsAgree: get(AllCheckState),
      CertNum: get(CertNumState),
      TermsList: get(TermsListState),
      TermsData: get(TermsSelector),
      authKeyValue: get(authKeyState),
      termsAgree: get(TermsAgreeState),
      isAgreeAllRequiredTerms: get(IsAgreeAllRequiredTermsSelector)
    }
  }
})
const uiData = atom<UiData>({
  key: 'uiData',
  default: {
    layoutsInsert: {
      mainBg: '#fff',
      certs: {
        type: '',
        borderColor: '#fff',
        backgroundColor: '#fff'
      },
      agency: {
        shape: '',
        actColor: '#fff'
      }
    },
    layoutsConfirm: {
      confirmHover: false,
      submitBtn: {
        borderRadius: 'none',
        fontSize: '13.5px',
        letterSpacing: '-1px',
        backgroundColor: '#fff',
        fontColor: '#fff',
        fontWeight: 400
      }
    },
    layoutsFooter: {
      color: '#fff',
      backgroundColor: '#fff'
    },
    layoutsTerms: {
      direction: '',
      shape: '',
      actColor: '#fff',
      borderRadius: 'none',
    },
    layoutsVerify: {
      verifyDir: '',
      cashSpace: '-1.3px',
      verifyBtn: {
        borderRadius: 'none',
        fontSize: '13.5px',
        letterSpacing: '0',
        backgroundColor: '#fff',
        fontColor: '#fff',
        fontWeight: 400
      },
      cancelBtn: {
        borderRadius: 'none',
        fontSize: '13.5px',
        letterSpacing: '0',
        backgroundColor: '#fff',
        fontColor: '#fff',
        fontWeight: 400
      }
    }
  }
})
const isViewState = atom<boolean>({
  key: 'isView',
  default: false
})
const uiInsertsStyle = selector<InsertStyleType>({
  key: 'uiCertsStyle',
  get: ({ get }) => get(uiData).layoutsInsert
})
const uiConfirmStyle = selector<ConfirmStyleType>({
  key: 'uiConfirmStyle',
  get: ({ get }) => get(uiData).layoutsConfirm
})
const uiTermsStyle = selector<TermsStyleType>({
  key: 'uiTermsStyle',
  get: ({ get }) => get(uiData).layoutsTerms
})
const uiVerifyStyle = selector<VerifyStyleType>({
  key: 'uiVerifyStyle',
  get: ({ get }) => get(uiData).layoutsVerify
})
const uiFooterStyle = selector<FooterStyleType>({
  key: 'uiFooterStyle',
  get: ({ get }) => get(uiData).layoutsFooter
})
const termsModalOpen = atom<boolean>({
  key: 'termsModalOpen',
  default: false
})
export {
  TelTypeState,
  TelNumState,
  TimeoutState,
  TransIdState,
  authKeyState,
  CertCheckState,
  VulnerableCheckState,
  TermsAgreeState,
  TermsListState,
  TermsSelector,
  AllCheckState,
  CertNumState,
  PartnerListData,
  RecoilStateList,
  uiData,
  isViewState,
  uiConfirmStyle,
  uiFooterStyle,
  uiInsertsStyle,
  uiTermsStyle,
  uiVerifyStyle,
  termsModalOpen,
  MvmoTermsState,
  MvnoCheckValue
}
